import { render } from "./ViewMoreStudent.vue?vue&type=template&id=7b057942&scoped=true"
import script from "./ViewMoreStudent.vue?vue&type=script&lang=js"
export * from "./ViewMoreStudent.vue?vue&type=script&lang=js"

import "./ViewMoreStudent.vue?vue&type=style&index=0&id=7b057942&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b057942"]])

export default __exports__